export const loadVPSAddons =
  () =>
  async (dispatch, getState, { api }) =>
    api.getVPSAddons().then(
      ({ result }) => result.addons || [],
      (err) => {
        console.error("Get hosting packages failed", err);
      },
    );
